var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "py-6" },
    [
      _c(
        "v-card",
        [
          _c("AccountMetaInfo", {
            attrs: { account: _vm.account },
            on: { save: _vm.updateAccount },
          }),
          _c(
            "v-card-title",
            [
              _c("h2", [_vm._v("Clients")]),
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  staticClass: "float-sm-right mt-2 mx-2",
                  attrs: { small: "", icon: "" },
                  on: {
                    click: function ($event) {
                      _vm.creatingClient = true
                    },
                  },
                },
                [
                  _c("v-icon", { staticClass: "mr-1" }, [
                    _vm._v("mdi-plus-box-outline"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm.creatingClient
            ? _c("NewClient", {
                attrs: { accountId: _vm.account.id },
                on: {
                  cancelClientCreate: function ($event) {
                    _vm.creatingClient = false
                  },
                  createReq: function ($event) {
                    _vm.creatingClient = true
                  },
                },
              })
            : _vm._e(),
          _c("v-divider"),
          _c(
            "v-card-text",
            [
              _vm.loadingClients
                ? _c(
                    "div",
                    {
                      staticClass:
                        "mt-auto d-flex align-center justify-center mb-8",
                    },
                    [
                      _c("v-progress-circular", {
                        staticClass: "px-8",
                        attrs: { indeterminate: "" },
                      }),
                      _c("span", [_vm._v("Fetching clients...")]),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "transition",
                { attrs: { name: "stf-fade" } },
                [
                  _c(
                    "v-container",
                    [
                      !_vm.loadingClients
                        ? _c(
                            "v-row",
                            { staticClass: "clients-list" },
                            _vm._l(_vm.clients, function (client) {
                              return _c(
                                "v-col",
                                {
                                  key: client.id,
                                  attrs: { cols: "12", md: "6" },
                                },
                                [
                                  _c(
                                    "v-container",
                                    { staticClass: "client-card py-4 px-4" },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          staticClass: "no-decoration",
                                          attrs: {
                                            to: `/pages/research/client/${client.id}`,
                                          },
                                        },
                                        [
                                          _c(
                                            "v-list-item",
                                            [
                                              _c(
                                                "v-list-item-content",
                                                [
                                                  _c(
                                                    "v-list-item-title",
                                                    {
                                                      staticClass:
                                                        "font-weight-bold",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(client.name)
                                                      ),
                                                    ]
                                                  ),
                                                  _c("v-list-item-subtitle", [
                                                    _vm._v(
                                                      " Address: " +
                                                        _vm._s(client.address) +
                                                        " "
                                                    ),
                                                  ]),
                                                  _c("v-list-item-subtitle", [
                                                    _vm._v(
                                                      " Phone: " +
                                                        _vm._s(client.phone) +
                                                        " "
                                                    ),
                                                  ]),
                                                  _c("v-list-item-subtitle", [
                                                    _vm._v(
                                                      " Status: " +
                                                        _vm._s(
                                                          client.status
                                                            ? "Active"
                                                            : "Inactive"
                                                        ) +
                                                        " "
                                                    ),
                                                  ]),
                                                  _c("v-list-item-subtitle", [
                                                    _vm._v(
                                                      " Created At: " +
                                                        _vm._s(
                                                          _vm.formatDate(
                                                            client.created_at
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]),
                                                  _c("v-list-item-subtitle", [
                                                    _vm._v(
                                                      " Updated At: " +
                                                        _vm._s(
                                                          _vm.formatDate(
                                                            client.updated_at
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            }),
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }